import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import BeliefsPage from '@/views/BeliefsPage.vue'
import ChurchSchedule from '@/views/ChurchSchedule.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/beliefs',
    name: 'Beliefs',
    component: BeliefsPage
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: ChurchSchedule
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 